import React, { useEffect, useState } from "react";
import { Form, Input, Button, Icon, DatePicker, Select, Steps, Descriptions, Alert, Checkbox, Radio, Spin, Tooltip } from "antd";
import { Vendor, VendorInvoice } from "../../../../../models/vendorPayouts";
import moment from "moment";
import { alertify, generate_query_set, handleApiExceptions, printRupee } from "../../../../../app_methods";
import { Text4 } from "../../../../../styles";
import TextArea from "antd/lib/input/TextArea";
import './index.scss';
import { VENDOR_APPROVAL_STATUS } from "../../../../../constants";

let VendorInvoiceForm = (props) => {
  const { form, vendorInvoice } = props;
  const { getFieldDecorator } = form;
  const validations = VendorInvoice.validations;
  const [vendors, setVendors] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetchVendors = async () => {
    setIsLoading(true);
    const response = await Vendor.list({ pageSize: 5000, current: 1 });
    if (!response.success) {
      setIsLoading(false);
      handleApiExceptions(response);
      return;
    }
    setVendors(generate_query_set(Vendor, response.data.results));
    setIsLoading(false);
  };

  useEffect(() => {
    fetchVendors();
  }, []);

  const saveVendorInvoice = async (values) => {
    if (vendorInvoice && vendorInvoice.id) {
      updateVendorInvoice(values);
      return;
    }
    setIsSaving(true);
    const response = await VendorInvoice.create(values);
    if (!response.success) {
      setIsSaving(false);
      handleApiExceptions(response);
      return;
    }
    handleSaveResponse(values, response);
  };

  const updateVendorInvoice = async (values) => {
    setIsSaving(true);
    const response = await vendorInvoice.update(values);
    if (!response.success) {
      setIsSaving(false);
      handleApiExceptions(response);
      return;
    }
    handleSaveResponse(values, response);
  };

  const handleSaveResponse = (values, response) => {
    setIsSaving(false);
    
    const is_approval_flow = Object.keys(response.data.invoice.approval).length > 1;
    if (!values.initiate_payment) {
      alertify("Success", `Invoice ${vendorInvoice.is_edit ? "updated" : "created"} successfully.`, "success");
    }
    else {
      if (response.data.transfer_initiated) {
        alertify("Success", `Invoice ${vendorInvoice.is_edit ? "updated" : "saved"}. Payment initiated successfully.`, "success")
      }
      else {
        if (is_approval_flow) {
          alertify("Success", `Invoice saved. Payment can be initiated after approval.`, "info")
        }
        else {
          alertify(`Invoice saved. Payment failed. : `, response.data.message, "error")
        }
      }
    }
    props.onInvoiceSave();
    // if (values.initiate_payment && !response.data.transfer_initiated) {
    //   alertify(`Invoice Saved. ${!response.data.approval.status === `approved` ? `Payment Failed.` : ``}`, response.data.message, "info");
    // } else if (values.initiate_payment && response.data.transfer_initiated) {
    //   alertify("Success", "Invoice is saved & payment has been initiated successfully.", "success")
    // } else {
    //   alertify("Success", `Invoice ${vendorInvoice.is_edit ? "updated" : "created"} successfully.`, "success");
    // }

  }

  const onSubmit = (e) => {
    form.validateFields((err, values) => {
      if (err) return;
      setIsSaving(true);
      values.issue_date = values.issue_date && values.issue_date.format("YYYY-MM-DD");
      values.due_date = values.due_date && values.due_date.format("YYYY-MM-DD");
      if (vendorInvoice.id) {
        updateVendorInvoice(values);
      } else {
        saveVendorInvoice(values);
      }
    });
  };

  const renderGstPercentage = () => {
    const formData = form.getFieldsValue();
    if (formData.amount && formData.gst_amount) {
      const percentage = ((100 * formData.gst_amount) / formData.amount) || 0;
      return `Calculated GST ${percentage.toFixed(3)} %`;
    }
  };

  const renderTdsAmount = () => {
    const formData = form.getFieldsValue();
    if (formData.amount && formData.tds_percentage) {
      const tds_amount = ((formData.amount * formData.tds_percentage) / 100) || 0;
      return <span>Calculated TDS {printRupee(tds_amount)}</span>;
    }
  };

  const renderPayableAmount = () => {
    const formData = form.getFieldsValue();
    if (formData.amount) {
      const tds_amount = ((formData.amount * formData.tds_percentage) / 100) || 0;
      return (parseFloat(formData.amount) + parseFloat(formData.gst_amount || 0) - parseFloat(tds_amount || 0)) || 0;
    }
    return 0;
  };

  const renderVendorForm = () => {
    const selectedVendor =
      vendors.find((x) => x.id === form.getFieldValue("vendor_id")) || {};

    let selectedBankDetail =
      selectedVendor.vendor_profile ? (selectedVendor.vendor_profile.vendor_bank_details.find((x) => x.id === form.getFieldValue("bank_detail_id")) || {}) : null;

    return (
      <div className={`row justify-content-center position-relative ${currentStep != 0 ? "d-none" : ""}`} style={{ height: 325 }}>
        <div className="position-absolute d-flex align-items-center" style={{ left: 90, bottom: 45, top: 0 }}>
          <div className="prev-button">
            <Tooltip title="Previous">
              <Button
                type="primary"
                onClick={() => {
                  setCurrentStep(0);
                }}
                icon="left"
                shape="circle"
                disabled
              />
            </Tooltip>
          </div>
        </div>
        <div className="col-6">
          <Spin spinning={isLoading}>
            <Form.Item label="Vendor" className="w-100">
              {getFieldDecorator("vendor_id", {
                rules: validations.vendor_id,
                initialValue: (vendorInvoice.vendor || {}).id
              })(
                <Select
                  placeholder="Select Vendor"
                  showSearch
                  filterOption={(input, option) =>
                    option?.props?.children
                      ?.toLowerCase()
                      ?.indexOf(input?.toLowerCase()) >= 0
                  }
                >
                  {vendors.map((vendor, index) => (
                    (vendor && VENDOR_APPROVAL_STATUS[vendor.status].label == "Active") && (
                      <Select.Option key={index} value={vendor.id}>
                        <div className='d-flex flex-column'>
                            <Text4 strong>{vendor.name}</Text4>
                            <Text4 type='secondary'>{vendor.email}</Text4>
                        </div>
                      </Select.Option>
                    )
                  ))}
                </Select>
              )}
            </Form.Item>

            <Form.Item label="Bank Details" className="w-100">
              {getFieldDecorator("bank_detail_id", {
                rules: validations.bank_detail_id,
                initialValue: vendorInvoice.bank_detail_id
              })(
                <Select
                  placeholder="Select Bank Details"
                  showSearch
                  filterOption={(input, option) =>
                    option.props.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {selectedVendor.vendor_profile ? selectedVendor.vendor_profile.vendor_bank_details.map((bank_detail, index) => (
                    <Select.Option key={index} value={(bank_detail || {}).id}>
                      <div className="d-flex flex-column">
                        <p className="m-0">  {`${bank_detail.account_number} `}</p>
                        <p className="m-0">  {`${bank_detail.account_ifsc}`}</p>
                      </div>
                    </Select.Option>

                  )) : null}
                </Select>
              )}
            </Form.Item>

            {selectedBankDetail && selectedBankDetail.id ? (
              <Form.Item label="Vendor Account Details">
                <Descriptions
                  className="mt-1"
                  title={false}
                  column={1}
                  style={{ backgroundColor: "#fff" }}
                  bordered
                  size="small"
                >
                  <Descriptions.Item label="Account Name">
                    {(selectedBankDetail || {}).name_on_bank || "---"}
                  </Descriptions.Item>
                  <Descriptions.Item label="Account Number">
                    {(selectedBankDetail || {}).account_number || "---"}
                  </Descriptions.Item>
                  <Descriptions.Item label="IFSC">
                    {(selectedBankDetail || {}).account_ifsc || "---"}
                  </Descriptions.Item>
                </Descriptions>
              </Form.Item>
            ) : null}
          </Spin>
        </div>

        <div className="position-absolute d-flex align-items-center" style={{ right: 90, bottom: 45, top: 0 }}>
          <div className="next-button">
            <Tooltip title="Next">
              <Button
                type="primary"
                onClick={() => {
                  form.validateFields(["vendor_id", "bank_detail_id"], {}, (err) => {
                    if (!err) {
                      setCurrentStep(1);
                    }
                  });
                }}
                icon="right"
                shape="circle"
              />
            </Tooltip>
          </div>
        </div>
      </div>
    );
  };

  const renderInvoiceDetailsForm = () => {
    return (
      <div className={`row justify-content-center position-relative ${currentStep != 1 ? "d-none" : ""}`} >
        <div className="position-absolute d-flex align-items-center" style={{ left: 90, bottom: 14, top: 0 }}>
          <div className="prev-button">
            <Tooltip title="Previous">
              <Button
                type="primary"
                onClick={() => {
                  setCurrentStep(0);
                }}
                icon="left"
                shape="circle"
              />
            </Tooltip>
          </div>
        </div>
        <div className="col-6">
          <Form.Item label="Invoice No.">
            {getFieldDecorator("number", {
              initialValue: vendorInvoice.number,
              rules: validations.number,
            })(<Input autoComplete="off" prefix={<Icon type="number" />} />)}
          </Form.Item>

          <Form.Item label="Issue Date">
            {getFieldDecorator("issue_date", {
              rules: validations.issue_date,
              initialValue: vendorInvoice.issue_date ? moment(vendorInvoice.issue_date) : undefined
            })(
              <DatePicker
                style={{ width: "100%" }}
                format="YYYY-MM-DD"
                showTime={false}
              />
            )}
          </Form.Item>

          <Form.Item label="Due Date">
            {getFieldDecorator("due_date", {
              rules: validations.due_date,
              initialValue: vendorInvoice.due_date ? moment(vendorInvoice.due_date) : undefined
            })(
              <DatePicker
                style={{ width: "100%" }}
                format="YYYY-MM-DD"
                disabledDate={(date) => moment(date).isBefore(form.getFieldValue('issue_date'))}
                showTime={false}
              />
            )}
          </Form.Item>

          <Form.Item label="Description">
            {getFieldDecorator("description", {
              initialValue: vendorInvoice.description,
              rules: validations.description,
            })(<TextArea autoSize={false} style={{ width: "100%" }} />)}
          </Form.Item>
        </div>
        <div className="position-absolute d-flex align-items-center" style={{ right: 90, bottom: 14, top: 0 }}>
          <div className="next-button">
            <Tooltip title="Next">
              <Button
                type="primary"
                onClick={() => {
                  form.validateFields(
                    ["number", "issue_date", "description"],
                    {},
                    (err) => {
                      if (!err) {
                        setCurrentStep(2);
                      }
                    }
                  );
                }}
                icon="right"
                shape="circle"
              />
            </Tooltip>
          </div>
        </div>
      </div>
    );
  };

  const rendeAmountTaxForm = () => {
    return (
      <div className={`row justify-content-center position-relative ${currentStep != 2 ? "d-none" : ""}`} style={{ height: 325 }}>
        <div className="position-absolute d-flex align-items-center" style={{ left: 90, bottom: 45, top: 0 }}>
          <div className="prev-button">
            <Tooltip title="Previous">
              <Button
                type="primary"
                onClick={() => {
                  setCurrentStep(1);
                }}
                icon="left"
                shape="circle"
              />
            </Tooltip>
          </div>
        </div>
        <div className="col-6">
          <Form.Item label="Gross Amount">
            {getFieldDecorator("amount", {
              initialValue: vendorInvoice.amount ? Number(vendorInvoice.amount).toFixed(3) : 0,
              rules: validations.amount,
            })(
              <Input
                style={{ width: "100%" }}
                autoComplete="off"
                prefix={
                  <span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />
                }
              />
            )}
          </Form.Item>

          <Form.Item label="GST Amount" help={renderGstPercentage()}>
            {getFieldDecorator("gst_amount", {
              initialValue: vendorInvoice.gst_amount ? Number(vendorInvoice.gst_amount).toFixed(3) : "0",
              rules: validations.gst_amount,
            })(
              <Input
                style={{ width: "100%" }}
                autoComplete="off"
                prefix={
                  <span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />
                }
              />
            )}
          </Form.Item>
          <Form.Item label="TDS %" help={renderTdsAmount()}>
            {getFieldDecorator("tds_percentage", {
              initialValue: vendorInvoice.tds_percentage ? Number(vendorInvoice.tds_percentage).toFixed(3) : "0",
              rules: validations.tds_percentage,
            })(
              <Input
                style={{ width: "100%" }}
                autoComplete="off"
                prefix={<Icon type="percentage" />}
              />
            )}
          </Form.Item>

          <Alert
            className="mt-3"
            message={
              <>
                <Text4 strong>Final Payout Amount:</Text4>{" "}
                {printRupee(renderPayableAmount())}
              </>
            }
          />
        </div>
        <div className="position-absolute d-flex align-items-center" style={{ right: 90, bottom: 45, top: 0 }}>
          <div className="next-button">
            <Tooltip title="Next">
              <Button
                type="primary"
                onClick={() => {
                  form.validateFields(
                    ["amount", "gst_amount", "tds_percentage"],
                    {},
                    (err) => {
                      if (!err) {
                        setCurrentStep(3);
                      }
                    }
                  );
                }}
                icon="right"
                shape="circle"
              />
            </Tooltip>
          </div>
        </div>
      </div>
    );
  };

  const renderSummary = () => {
    const selectedVendor = vendors.find((x) => x.id === form.getFieldValue("vendor_id")) || {};
    let selectedBankDetail =
      selectedVendor.vendor_profile ? (selectedVendor.vendor_profile.vendor_bank_details.find((x) => x.id === form.getFieldValue("bank_detail_id")) || {}) : null;

    const paymentOptions1 = [
      {
        label: 'IMPS',
        value: 'IMPS'
      },
      {
        label: 'NEFT',
        value: 'NEFT'
      },
    ]

    const paymentOptions2 = [
      {
        label: 'IMPS',
        value: 'IMPS'
      },
      {
        label: 'NEFT',
        value: 'NEFT'
      },
      {
        label: 'RTGS',
        value: 'RTGS'
      },

    ]

    const paymentOptions3 = [
      {
        label: 'RTGS',
        value: 'RTGS'
      },
      {
        label: 'NEFT',
        value: 'NEFT'
      }

    ]

    const renderPaymentModeOptions = (amount) => {
      return ((amount < 200000) ? paymentOptions1 : (amount >= 200000 && amount <= 500000) ? paymentOptions2 : paymentOptions3)
    }

    return (
      <div className={`row justify-content-center position-relative ${currentStep != 3 ? "d-none" : ""}`} style={{ minHeight: 325 }}>
        <div className="position-absolute d-flex align-items-center" style={{ left: 90, bottom: 45, top: 0 }}>
          <div className="prev-button">
            <Tooltip title="Previous">
              <Button
                type="primary"
                onClick={() => {
                  setCurrentStep(2);
                }}
                icon="left"
                shape="circle"
              />
            </Tooltip>
          </div>
        </div>
        <div className="col-6">
          <Alert
            message={
              <>
                Payout of <strong>{printRupee(renderPayableAmount())}</strong>{" "}
                would be initiated to the following beneficiary account.
              </>
            }
          />
          <Descriptions
            className="mt-3"
            selectedVendorProfile
            title={false}
            column={1}
            style={{ backgroundColor: "#fff" }}
            bordered
            size="small"
          >
            <Descriptions.Item label="Account Name">
              {(selectedBankDetail || {}).name_on_bank || "---"}
            </Descriptions.Item>
            <Descriptions.Item label="Account Number">
              {(selectedBankDetail || {}).account_number || "---"}
            </Descriptions.Item>
            <Descriptions.Item label="IFSC">
              {(selectedBankDetail || {}).account_ifsc || "---"}
            </Descriptions.Item>
          </Descriptions>
          {vendorInvoice.status !== "Unapproved" ? (
            <div className="mt-2">
              {getFieldDecorator("initiate_payment", {
                valuePropName: "checked",
                initialValue: false,
              })(<Checkbox>Initiate Invoice Payment Now</Checkbox>)}
            </div>
          ) : null}

          {
            form.getFieldValue('initiate_payment') ? (
              <div className="mt-3">
                <Form.Item label="Payment Mode">
                  {getFieldDecorator("payment_mode", {
                    rules: [{ required: true, message: "Please select the payment mode." }],
                  })(
                    <Radio.Group options={renderPaymentModeOptions(renderPayableAmount())} />
                  )}
                </Form.Item>
              </div>
            ) : null
          }
          <div className="w-100 d-flex justify-content-center mt-4">
            <Button loading={isSaving} type="primary" onClick={onSubmit}>
              {form.getFieldValue("initiate_payment")
                ? "Initiate Payment"
                : "Save Invoice"}
            </Button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Steps>
        <Steps.Step
          status={currentStep >= 0 ? "finish" : ""}
          onClick={() => {
            if (currentStep >= 0) setCurrentStep(0);
          }}
          style={{ cursor: "pointer" }}
          title="Vendor"
          icon={<Icon type="user" />}
        />
        <Steps.Step
          status={currentStep >= 1 ? "finish" : ""}
          onClick={() => {
            if (currentStep >= 1) setCurrentStep(1);
          }}
          style={{ cursor: "pointer" }}
          title="Invoice Details"
          icon={<Icon type="solution" />}
        />
        <Steps.Step
          status={currentStep >= 2 ? "finish" : ""}
          onClick={() => {
            if (currentStep >= 2) setCurrentStep(2);
          }}
          style={{ cursor: "pointer" }}
          title="Amount & Tax"
          icon={<span dangerouslySetInnerHTML={{ __html: `&#8377; ` }} />}
        />
        <Steps.Step
          status={currentStep >= 3 ? "finish" : ""}
          onClick={() => {
            if (currentStep >= 3) setCurrentStep(3);
          }}
          style={{ cursor: "pointer" }}
          title="Verify & Pay"
          icon={<Icon type="unordered-list" />}
        />
      </Steps>
      <Form style={{ marginTop: 30, overflow: 'hidden' }} className="vendor-invoice-form">
        <div style={{ minHeight: 325 }}>
          {renderVendorForm()}
          {renderInvoiceDetailsForm()}
          {rendeAmountTaxForm()}
          {renderSummary()}
        </div>
      </Form>
    </>
  );
};

VendorInvoiceForm = Form.create()(VendorInvoiceForm);
export { VendorInvoiceForm };
